import styled, { css } from 'styled-components'

import checkIcon from 'assets/images/check-icon-white.svg'

import { FemiColor } from '../../constants'
import { FemiDescription, FemiTitle } from '../../styles'

const planBodyStyles = css`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const StyledFemiDiscountOffer = {
  Content: styled.div`
    padding-bottom: 88px;
  `,
  Title: styled(FemiTitle)`
    margin-bottom: 16px;

    mark {
      position: relative;
      z-index: 0;
      display: inline-block;
      margin-top: 4px;
      padding: 0 19px;
      background: none;
      color: inherit;
      font-family: inherit;
      font-style: italic;
      font-weight: 400;

      &::before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 3px;
        right: 0;
        bottom: -3px;
        left: 0;
        background-color: ${FemiColor.PINK_LIGHT};
      }
    }
  `,
  Description: styled(FemiDescription)`
    margin-bottom: 24px;
  `,
  Plans: styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  Tag: styled.p<{ isDark?: boolean }>`
    padding: 4px 12px;
    border-radius: 16px 16px 0 0;
    background-color: ${({ isDark }) =>
      isDark ? FemiColor.BLACK : FemiColor.GRAY_LIGHT};
    color: ${({ isDark }) => (isDark ? FemiColor.PINK : FemiColor.GRAY)};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
    text-transform: uppercase;
  `,
  CurrentPlanBody: styled.div`
    ${planBodyStyles};
    padding: 16px 15px;
    border: 1.5px solid ${FemiColor.GRAY_LIGHT};
    border-top: none;
    border-radius: 0 0 16px 16px;
    background-color: ${FemiColor.WHITE};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  `,
  NewPlanBody: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border: 1.5px solid ${FemiColor.BLACK};
    border-top: none;
    border-radius: 0 0 16px 16px;
    background-color: ${FemiColor.GRAY_SURFACE};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  `,
  PlanRow: styled.div`
    ${planBodyStyles};
  `,
  Check: styled.span`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${FemiColor.BLACK};
    background-image: url(${checkIcon});
    background-position: center;
    background-repeat: no-repeat;
  `,
  PlanInfo: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
  `,
  PlanName: styled.p`
    color: ${FemiColor.BLACK};
    font-size: 17px;
    font-weight: 600;
    line-height: 26px;
    text-transform: uppercase;
  `,
  PlanPrice: styled.p`
    display: flex;
    gap: 4px;
    color: ${FemiColor.GRAY};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  `,
  OldPrice: styled.span`
    color: ${FemiColor.GRAY};
    text-decoration: line-through;
    text-decoration-color: ${FemiColor.STRIKE};
  `,
  Divider: styled.span`
    align-self: stretch;
    border-inline-start: 1px dashed ${FemiColor.BLACK};
  `,
  PricePerDay: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 64px;
  `,
  DailyPrice: styled.p`
    color: ${FemiColor.DARK};
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  `,
  PerDay: styled.p`
    color: ${FemiColor.GRAY};
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  `,
  Separator: styled.div`
    height: 1px;
    background-color: ${FemiColor.GRAY_LIGHT};
  `,
  TodayRow: styled.div`
    display: flex;
    justify-content: space-between;
    color: ${FemiColor.BLACK};
    font-size: 17px;
    font-weight: 500;
    line-height: 26px;
  `,
  Disclaimer: styled.p`
    color: ${FemiColor.GRAY};
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;

    strong {
      font-weight: 600;
    }
  `,
  DiscountStart: styled.p`
    color: ${FemiColor.GRAY};
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    text-align: center;
  `,
}
